import type { MenuItem, WebConfig } from '@core/stores/types'

const menuPositions: Record<string, keyof WebConfig> = {
    social: 'socialMenu',
    footer: 'footerMenu',
    header: 'headerMenu',
    support: 'supportMenu',
    company: 'companyMenu',
    ecosystem: 'ecosystemMenu',
}

const configFields = [
    'bio', 'homePage', 'appName', 'baseUrl', 'tenantName', 'description', 'language', 'type',
    'email', 'phone', 'logoUrl', 'faviconUrl', 'contactPerson', 'contactEmail', 'contactPhone',
    'contactAddress', 'hasMembership', 'memberCanRegister', 'memberCanLogin',
] as const

// Copies the /web-config response into @core's generalStore.webConfig, field for field like
// generalStore.loadWebConfig() (which only runs in the browser).
export const applyWebConfig = (webConfig: WebConfig, res: { webConfig?: Record<string, any>, menus?: MenuItem[] } | null) => {
    if (!res) return

    if (res.webConfig) {
        for (const field of configFields) {
            webConfig[field] = res.webConfig[field]
        }
    }

    for (const menu of res.menus || []) {
        const list = menuPositions[menu.linkPosition || '']
        if (list) (webConfig[list] as MenuItem[]).push(menu)
    }

    for (const list of Object.values(menuPositions)) {
        (webConfig[list] as MenuItem[]).sort((a, b) => (a.position ?? 0) - (b.position ?? 0))
    }
}
